import { render } from "./CommerceDeptView.vue?vue&type=template&id=6d0a929a"
import script from "./CommerceDeptView.vue?vue&type=script&lang=js"
export * from "./CommerceDeptView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__